import {Component, ElementRef, HostListener, OnInit, signal, computed} from '@angular/core';
import {NavigationEnd, Router, RouterLink} from "@angular/router";
import {AuthService} from "../../services";
import {NavItem} from "./nav-item.entity";
import {Permission} from "../../types";
import {NgOptimizedImage} from "@angular/common";
import {BreadcrumbComponent} from "../breadcrumbs/breadcrumbs.component";
import {NetworkStatusBannerComponent} from "../network-status-banner/network-status-banner.component";
// import {DEDICATED_REPORT_PATHS} from "../../../components/feature/reports/report-permissions";

@Component({
    selector: 'app-top-nav',
    imports: [
        RouterLink,
        NgOptimizedImage,
        BreadcrumbComponent,
        NetworkStatusBannerComponent
    ],
    templateUrl: './top-nav.component.html',
    standalone: true,
    styleUrl: './top-nav.component.scss'
})
export class TopNavComponent implements OnInit {

    userName = signal('');
    protected showUserDropdown = signal<boolean>(false);

    private _showMobileMenu = signal(false);
    activeMobileDropdown: string | null = null;

    showMobileMenu = computed(() => this._showMobileMenu());

    activeDropdown: string | null = null;
    readonly dropdownPanelPosition = signal<{ top: number; left: number; minWidth: number } | null>(null);

    navItems: NavItem[] = [
        {path: 'sales-dashboard', label: 'Home', canAccess: false},
        {
            label: 'Dashboards',
            path: 'dashboards',
            canAccess: true,
            isDropdown: true,
            children: [
                {path: 'inventory/inventory-trend', label: 'Inventory Trend', canAccess: false},
                {path: 'order-performance', label: 'Order Performance', canAccess: true},
                {path: 'lead-time', label: 'Reliability Dashboard', canAccess: true},
                {path: 'delivery-status', label: 'Flexibility Dashboard', canAccess: true},
                {path: 'delivery-reliability', label: 'Delivery Reliability', canAccess: false},
                {path: 'finish-good-stores/dashboard', label: 'FG Pulse', canAccess: true},
                {path: 'purchase-requisition/dashboard-summary', label: 'PR Dashboard', canAccess: false},
                {path: 'supplier-price-variation', label: 'Supplier Price Analysis', canAccess: false},
                {path: 'email-signature', label: 'Email Signature', canAccess: true},
            ]
        },
        {
            label: 'Sales',
            path: 'sales-order',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'sales-order', label: 'Orders', canAccess: false},
                {path: 'sales-order/item', label: 'Order Items', canAccess: false},
                {path: 'sales-order/production-batch', label: 'Production Batch', canAccess: false},
                {path: 'sales-order/production-release', label: 'Production Release', canAccess: false},
                {path: 'sales-order/production-status', label: 'Production Status', canAccess: false},
                {path: 'sales-order/production-plan-cards', label: 'Production Plan Cards', canAccess: false}
            ]
        },

        {
            label: 'Invoices & Credits',
            path: 'invoice',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'invoice', label: 'View Invoices', canAccess: false},
                {path: 'invoice/create', label: 'Create Invoice', canAccess: false},
                {path: 'invoice/track', label: 'Track Invoices', canAccess: false},
                {path: 'invoice/signed-copy-submit', label: 'Signed Copy Submit', canAccess: false},
                {path: 'credit-note', label: 'Credit Notes', canAccess: false}
            ]
        },

        {
            label: 'Product',
            path: 'product-development',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'product-price', label: 'Product Price', canAccess: false},
                {path: 'product-development', label: 'Product Development', canAccess: false},
                {path: 'product-development/pending-bom', label: 'Pending BOM', canAccess: false},
                {path: 'product-development/view-bom', label: 'View BOM', canAccess: false},
                {path: 'compliance-certificate', label: 'Certificates', canAccess: false},
                {path: 'plans-per-sheet', label: 'Plans per sheet', canAccess: false},
                {path: 'currency-exchange-rate', label: 'Exchange Rate', canAccess: false},
            ]
        },
        {
            label: 'Production',
            path: 'production-planing',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'production-planing', label: 'Plan Production', canAccess: false},
                {path: 'smart-planning', label: 'Smart Planning', canAccess: false},
                {path: 'auto-schedule', label: 'Auto Schedule', canAccess: false},
                {path: 'task-tracker', label: 'Task Tracker', canAccess: false},
                {path: 'production-update-status', label: 'Update Production', canAccess: true},
                {path: 'production-update', label: 'Bulk Update Production', canAccess: false},
                {path: 'delivery-change-request', label: 'Date Change Request', canAccess: false},

            ]
        },
        {path: 'packaging', label: 'Packaging', canAccess: false},
        {path: 'ncr', label: 'NCR', canAccess: false},
        {path: 'production-status', label: 'Production Status', canAccess: false},
        {path: 'dispatch-note', label: 'Dispatch', canAccess: false},
        {path: 'shipment-tracker', label: 'Shipment Tracker', canAccess: false},
        {
            label: 'Reports',
            path: 'reports',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'reports/sales-report', label: 'Order Reports', canAccess: false},
                {path: 'reports/invoice-report', label: 'Sales Reports', canAccess: false},
                {path: 'reports/stores-report', label: 'Stores Reports', canAccess: false},
                // {path: 'reports/gin-report', label: 'Goods Issued Note Report', canAccess: false},
                // {path: 'reports/grn-report', label: 'Goods Received Note Report', canAccess: false},
                // {path: 'reports/mrn-report', label: 'Material Return Note Report', canAccess: false},
                // {path: 'reports/po-tracking-report', label: 'PO Tracking Report', canAccess: false},
                {path: 'reports/purchase-report', label: 'Purchase Reports', canAccess: false},
                {path: 'reports/ncr-report', label: 'NCR Reports', canAccess: false},
                {path: 'reports/stock-report', label: 'Stock Report', canAccess: false},
                {path: 'reports/invoice-download', label: 'Invoice PDF Download', canAccess: false}
            ]
        },
        
        {
            label: 'Work Order',
            path: 'work-order',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'work-order', label: 'Work Order', canAccess: false},
                {path: 'work-order/create', label: 'Work Order Create', canAccess: false},
            ]
        },
        {
            label: 'Customers',
            path: 'customer',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'customer', label: 'Customer List', canAccess: false},
                {path: 'sales-map', label: 'Sales Map', canAccess: false},
                {path: 'customer/customer-grid', label: 'Customer Grid', canAccess: false},
                {path: 'customer/outstanding', label: 'Customer Outstanding', canAccess: false}
            ]
        },
        {
            label: 'Supplier',
            path: 'supplier',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'supplier', label: 'Supplier List', canAccess: false},
                {path: 'supplier/create', label: 'Create Supplier', canAccess: false},
                {path: 'supplier-price', label: 'Supplier Stand Prices', canAccess: false},
            ]
        },
        {
            label: 'Inventory',
            path: 'inventory',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'inventory/raw-materials', label: 'Raw Materials', canAccess: false},
                {path: 'inventory/finished-products', label: 'Finished Products', canAccess: false},
                // {path: 'inventory/finish-good', label: 'Finish Good', canAccess: false},
                {path: 'inventory/finish-goods', label: 'Finish Goods', canAccess: false},
                {path: 'finish-good-stores', label: 'Finish Good Stores', canAccess: false},
                {path: 'grn', label: 'Good Receive Note', canAccess: false},
                {path: 'mci', label: 'Material Conversion Intake', canAccess: false},
                {path: 'stock-barcode', label: 'Stock Barcodes', canAccess: false},
                {path: 'gin', label: 'Good Issue Note', canAccess: false},
                {path: 'material-return-note', label: 'Material Return Note', canAccess: false},
            ]
        },
                {
            label: 'Purchasing ',
            path: 'purchase-order',
            canAccess: false,
            isDropdown: true,
            children: [
                {path: 'purchase-order', label: 'Purchase order', canAccess: false},
                {path: 'purchase-requisition', label: 'Purchase requisition', canAccess: true},
            ]
        }
    ];

    constructor(
        private router: Router,
        private authService: AuthService,
        private elementRef: ElementRef
    ) {
        const user = this.authService.getUserInfo();
        this.userName.set(user.name);

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.clearDesktopDropdown();
                this.activeMobileDropdown = null;
                this.showUserDropdown.set(false);
                this._showMobileMenu.set(false);
                document.body.style.overflow = '';
            }
        });
    }

    // Mobile menu methods
    toggleMobileMenu(): void {
        this._showMobileMenu.update(show => {
            const next = !show;
            document.body.style.overflow = next ? 'hidden' : '';
            return next;
        });
        if (this._showMobileMenu()) {
            this.showUserDropdown.set(false);
            this.clearDesktopDropdown();
        }
    }

    closeMobileMenu(): void {
        document.body.style.overflow = '';
        this._showMobileMenu.set(false);
        this.activeMobileDropdown = null;
    }

    toggleMobileDropdown(label: string): void {
        this.activeMobileDropdown = this.activeMobileDropdown === label ? null : label;
    }

    @HostListener('document:keydown.escape')
    onEscapePress() {
        this.clearDesktopDropdown();
        this.activeMobileDropdown = null;
        this._showMobileMenu.set(false);
        this.showUserDropdown.set(false);
        document.body.style.overflow = '';
    }

    ngOnInit() {
        this.setNavigationPermissions();
    }

    private setNavigationPermissions() {
        const userData = this.authService.getUserAuthSession();
        if (userData) {
            try {
                let permissions: Permission[] = [];
                if (typeof userData.permissions === 'string') {
                    permissions = JSON.parse(userData.permissions);
                } else {
                    permissions = (userData.permissions as Permission[]) || [];
                }

                const flattenPermissions = (list: Permission[] | undefined): Permission[] => {
                    const out: Permission[] = []
                    const walk = (p: Permission) => {
                        out.push(p)
                        const subs = (p as any)?.subPermissions as Permission[] | undefined
                        if (Array.isArray(subs)) {
                            subs.forEach(walk)
                        }
                    }
                    ;(Array.isArray(list) ? list : []).forEach(walk)
                    return out
                }

                const flatPermissions = flattenPermissions(permissions)

                this.navItems = this.navItems.map(item => {
                    if (item.children) {
                        const childrenWithAccess = item.children.map(child => {
                            const childPath = child.path;
                            const hasReportsPermission = item.path === 'reports' &&
                                flatPermissions.some(p => p.path === 'reports' && p.canAccess);                        
                            const hasPermission = item.path === 'reports'
                                ? hasReportsPermission
                                : flatPermissions.some(p => p.path === childPath && p.canAccess);
                            return {
                                ...child,
                                canAccess: child.canAccess || hasPermission
                            };
                        });
                        return {
                            ...item,
                            canAccess: item.canAccess ||
                                flatPermissions.some(p => p.path === item.path && p.canAccess) ||
                                childrenWithAccess.some(child => child.canAccess),
                            children: childrenWithAccess
                        };
                    }
                    return {
                        ...item,
                        canAccess: item.canAccess || flatPermissions.some(p => p.path === item.path && p.canAccess)
                    };
                });
            } catch (error) {
                console.error('Error parsing permissions:', error);
            }
        }
    }

    toggleDropdown(event: Event, label: string): void {
        this.showUserDropdown.set(false);
        this._showMobileMenu.set(false);
        event.stopPropagation();
        if (this.activeDropdown === label) {
            this.clearDesktopDropdown();
            return;
        }
        this.activeDropdown = label;
        const el = event.currentTarget as HTMLElement;
        this.applyDropdownPanelPosition(el);
    }

    /** Current desktop flyout menu (by open label) */
    dropdownMenu(): NavItem | null {
        const label = this.activeDropdown;
        if (!label) {
            return null;
        }
        const item = this.navItems.find(
            i => i.label === label && i.canAccess && i.isDropdown && i.children?.length
        );
        return item ?? null;
    }

    onDesktopNavLinkClick(): void {
        this.clearDesktopDropdown();
    }

    private clearDesktopDropdown(): void {
        this.activeDropdown = null;
        this.dropdownPanelPosition.set(null);
    }

    private applyDropdownPanelPosition(anchor: HTMLElement): void {
        const r = anchor.getBoundingClientRect();
        const minWidth = Math.max(r.width, 168);
        let left = r.left;
        const pad = 8;
        const maxLeft = window.innerWidth - minWidth - pad;
        if (left > maxLeft) {
            left = Math.max(pad, maxLeft);
        }
        this.dropdownPanelPosition.set({
            top: r.bottom + 4,
            left,
            minWidth,
        });
    }

    @HostListener('window:resize')
    @HostListener('window:scroll')
    syncDropdownPanelPosition(): void {
        if (!this.activeDropdown) {
            return;
        }
        const root = this.elementRef.nativeElement as HTMLElement;
        const buttons = root.querySelectorAll<HTMLElement>('[data-nav-dropdown]');
        let btn: HTMLElement | null = null;
        buttons.forEach((b) => {
            if (b.getAttribute('data-nav-dropdown') === this.activeDropdown) {
                btn = b;
            }
        });
        if (btn) {
            this.applyDropdownPanelPosition(btn);
        }
    }

    isActive(route: string): boolean {
        return this.router.url === '/' + route || this.router.url.startsWith('/' + route + '/');
    }

    logOut() {
        this.showUserDropdown.set(false);
        this._showMobileMenu.set(false);
        this.clearDesktopDropdown();
        document.body.style.overflow = '';
        this.authService.userSignOut();
    }

    toggleUserDropdown() {
        this.showUserDropdown.update(prev => !prev);
        this.clearDesktopDropdown();
        if (this.showUserDropdown()) {
            this._showMobileMenu.set(false);
        }
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        const target = event.target as HTMLElement;
        const insideNav = this.elementRef.nativeElement.contains(target);

        if (!target.closest('#user-dropdown') && !target.closest('.nav-user-trigger')) {
            this.showUserDropdown.set(false);
        }

        if (
            !target.closest('.nav-dropdown-root') &&
            !target.closest('.nav-desktop-dropdown-panel')
        ) {
            this.clearDesktopDropdown();
        }

        if (!insideNav) {
            document.body.style.overflow = '';
            this._showMobileMenu.set(false);
            this.activeMobileDropdown = null;
        }
    }
}
